// src/hooks/useAuth.ts
import { useState, useEffect } from "react";
import {
  loginApi,
  logoutApi,
} from "../services/authApi";
import { useDispatch } from "react-redux";
import {
  retrieveAccessToken,
  clearAccessToken,
  storeAccessToken,
} from "../store/auth/storeToken";
import { logoutUser } from "../store/auth/actions"; // optional

// src/hooks/useAuth.ts
export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<string | null>(retrieveAccessToken());
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const checkToken = () => {
  //     setToken(retrieveAccessToken());
  //   };
  //   window.addEventListener("storage", checkToken);
  //   return () => window.removeEventListener("storage", checkToken);
  // }, []);
  useEffect(() => {
    // const interval = setInterval(() => {
    const currentToken = retrieveAccessToken();
    setToken(currentToken);
    // }, 500); // poll every 500ms

    // return () => clearInterval(interval);
  }, []);

  const login = async (email: string, password: string) => {
    setLoading(true);
    try {
      const { data } = await loginApi(email, password);
      storeAccessToken(data);
      setToken(data.accessToken); // this will update state
      return data;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    clearAccessToken();
    setToken(null); // trigger re-render
    dispatch(logoutUser());
    logoutApi();
  };

  return {
    login,
    logout,
    loading,
    isAuthenticated: !!token,
    token, // 👈 expose the token
  };
};
